import { FC } from "react";
import { Modal } from "antd";

type PrivacyModalProps = {
  open: boolean;
  title: string;
  policy: string;
  onOk: () => void;
  onCancel: () => void;
};

const PrivacyModal: FC<PrivacyModalProps> = ({
  open,
  title,
  policy,
  onOk,
  onCancel,
}) => {
  return (
    <Modal open={open} title={title} onOk={onOk} onCancel={onCancel}>
      <p>
        La Secretaría de Bienestar del Estado de Quintana Roo, a través de la
        Dirección de Faro, informa que es la responsable del tratamiento de los
        datos personales recabados de usted, los cuales serán utilizados para
        Realizar la Solicitud de Inscripción al Programa, comprobar que cumple
        con los criterios de elegibilidad al Programa, y generar el Padrón de
        Personas Beneficiarias del Programa; asumiendo la obligación de cumplir
        con las medidas legales y de seguridad suficientes para proteger tales
        datos personales. Para mayor detalle consulte nuestro Aviso de
        Privacidad Integral en:{" "}
        <a
          target="_blank"
          href="https://sebien.qroo.gob.mx/avisos-de-privacidad-de-la-sebien/"
        >
          https://sebien.qroo.gob.mx/avisos-de-privacidad-de-la-sebien/
        </a>
        , en la sección “Avisos de privacidad”.{" "}
      </p>
    </Modal>
  );
};

export default PrivacyModal;
